import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ArrowUpIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='arrow-up'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M12 20.25V3.75'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.25 10.5L12 3.75L18.75 10.5'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowUpIcon;
